/**
 * WD Transaction cancellation form — client-side validation (Shopify contact still validates server-side).
 * Mirrors wd-contact-form.js for shared fields (incl. full-name rules); adds order_number, branch, reason.
 */
(function () {
  function t(key) {
    if (typeof window.wdTransactionCancellationFormStrings === 'object' && window.wdTransactionCancellationFormStrings[key]) {
      return window.wdTransactionCancellationFormStrings[key];
    }
    return key;
  }

  function digitsOnly(s) {
    return String(s || '').replace(/\D/g, '');
  }

  function normalizeIsraeliPhoneDigits(raw) {
    var d = digitsOnly(raw);
    if (!d) return '';
    if (d.charAt(0) === '0') return d;
    if (d.indexOf('972') === 0) {
      var rest = d.slice(3);
      if (!rest) return d;
      if (rest.charAt(0) === '0') rest = rest.slice(1);
      return '0' + rest;
    }
    return d;
  }

  function isAllSameDigit(d) {
    return d.length > 0 && /^(\d)\1+$/.test(d);
  }

  function hasIllegalControlChars(s) {
    return /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/.test(s);
  }

  /**
   * Full name: letters (any script) + combining marks, spaces, hyphen / Hebrew maqaf, apostrophe / geresh.
   * No digits; at least one letter (not "-" or "׳" alone).
   * @returns {'digits'|'badchar'|'noletter'|null}
   */
  function contactNameValidationIssue(trimmed) {
    if (!trimmed) return null;
    if (/\p{Nd}/u.test(trimmed)) return 'digits';
    if (!/^[\p{L}\p{M}\s\-'\u2019\u05F3\u05BE]+$/u.test(trimmed)) return 'badchar';
    if (!/\p{L}/u.test(trimmed)) return 'noletter';
    return null;
  }

  function wireNameFieldGuards(form) {
    var nameEl = form.querySelector('[data-wd-rule="name"]');
    if (!nameEl || nameEl.getAttribute('data-wd-name-guard') === '1') return;
    nameEl.setAttribute('data-wd-name-guard', '1');
    nameEl.addEventListener('beforeinput', function (ev) {
      if (!ev || typeof ev.inputType !== 'string' || ev.inputType.indexOf('insert') !== 0) return;
      if (ev.data == null || ev.data === '') return;
      if (ev.data.length === 1 && /\p{Nd}/u.test(ev.data)) {
        ev.preventDefault();
      }
    });
    nameEl.addEventListener('input', function () {
      var v = nameEl.value;
      var next = v.replace(/\p{Nd}/gu, '');
      if (next !== v) {
        nameEl.value = next;
      }
    });
  }

  function isReasonableEmailShape(s) {
    if (!s || s.length < 5 || s.length > 254) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s);
  }

  function selectHasSelectableOption(sel) {
    if (!sel || !sel.options) return false;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.disabled) continue;
      if (o.value && String(o.value).trim() !== '') return true;
    }
    return false;
  }

  function isValidIsraeliPhoneStructure(d) {
    if (!d || isAllSameDigit(d)) return false;
    if (d.length === 9) {
      return /^0[23489]\d{7}$/.test(d);
    }
    if (d.length === 10) {
      if (d.indexOf('05') === 0) return /^05\d{8}$/.test(d);
      if (d.indexOf('07') === 0) return /^07\d{8}$/.test(d);
      return false;
    }
    return false;
  }

  function clearErrors(form) {
    form.querySelectorAll('[data-wd-error]').forEach(function (el) {
      el.textContent = '';
      el.classList.add('hidden');
    });
  }

  function showError(form, rule, message) {
    var el = form.querySelector('[data-wd-error="' + rule + '"]');
    if (!el) return;
    el.textContent = message;
    el.classList.remove('hidden');
  }

  function focusFirstInvalid(form) {
    var order = ['name', 'phone', 'email', 'order_number', 'branch', 'reason', 'terms'];
    for (var i = 0; i < order.length; i++) {
      var rule = order[i];
      var err = form.querySelector('[data-wd-error="' + rule + '"]');
      if (!err || err.classList.contains('hidden')) continue;
      var inp =
        rule === 'branch'
          ? form.querySelector('[data-wd-branch-select]')
          : form.querySelector('[data-wd-rule="' + rule + '"]');
      if (inp) {
        try {
          inp.focus({ preventScroll: false });
        } catch (e2) {
          inp.focus();
        }
        if (typeof inp.scrollIntoView === 'function') {
          inp.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
      break;
    }
  }

  function validate(form) {
    clearErrors(form);
    var ok = true;

    var name = form.querySelector('[data-wd-rule="name"]');
    if (name) {
      var nv = (name.value || '').trim();
      if (nv.length < 1) {
        showError(form, 'name', t('err_name'));
        ok = false;
      } else if (hasIllegalControlChars(nv)) {
        showError(form, 'name', t('err_chars'));
        ok = false;
      } else if (nv.length > 500) {
        showError(form, 'name', t('err_name_max'));
        ok = false;
      } else {
        var nameIssue = contactNameValidationIssue(nv);
        if (nameIssue === 'digits') {
          showError(form, 'name', t('err_name_digits'));
          ok = false;
        } else if (nameIssue === 'badchar') {
          showError(form, 'name', t('err_name_invalid_chars'));
          ok = false;
        } else if (nameIssue === 'noletter') {
          showError(form, 'name', t('err_name_no_letters'));
          ok = false;
        }
      }
    }

    var phone = form.querySelector('[data-wd-rule="phone"]');
    if (phone) {
      var raw = phone.value || '';
      if (hasIllegalControlChars(raw)) {
        showError(form, 'phone', t('err_chars'));
        ok = false;
      } else {
        var d = normalizeIsraeliPhoneDigits(raw);
        if (!isValidIsraeliPhoneStructure(d)) {
          showError(form, 'phone', t('err_phone'));
          ok = false;
        } else {
          var patStr = phone.getAttribute('data-phone-pattern');
          if (patStr) {
            try {
              var re = new RegExp(patStr);
              if (!re.test(d)) {
                showError(form, 'phone', t('err_phone'));
                ok = false;
              }
            } catch (e) {
              console.warn('[WD TCF] Invalid phone regex pattern in data-phone-pattern:', patStr, e);
            }
          }
        }
      }
    }

    var email = form.querySelector('[data-wd-rule="email"]');
    if (email) {
      var ev = (email.value || '').trim();
      if (!ev) {
        showError(form, 'email', t('err_email_required'));
        ok = false;
      } else if (hasIllegalControlChars(ev)) {
        showError(form, 'email', t('err_chars'));
        ok = false;
      } else if (!isReasonableEmailShape(ev) || !email.checkValidity()) {
        showError(form, 'email', t('err_email_invalid'));
        ok = false;
      }
    }

    var orderNum = form.querySelector('[data-wd-rule="order_number"]');
    if (orderNum) {
      var ov = (orderNum.value || '').trim();
      if (ov.length < 1) {
        showError(form, 'order_number', t('err_order_number'));
        ok = false;
      } else if (ov.length < 3) {
        showError(form, 'order_number', t('err_order_number_min'));
        ok = false;
      } else if (hasIllegalControlChars(ov)) {
        showError(form, 'order_number', t('err_chars'));
        ok = false;
      } else if (ov.length > 100) {
        showError(form, 'order_number', t('err_order_number_max'));
        ok = false;
      }
    }

    var branch = form.querySelector('[data-wd-branch-select]');
    if (branch) {
      if (!selectHasSelectableOption(branch)) {
        showError(form, 'branch', t('err_branch_options'));
        ok = false;
      } else {
        var bv = branch.value ? String(branch.value).trim() : '';
        if (!bv) {
          showError(form, 'branch', t('err_branch'));
          ok = false;
        } else if (hasIllegalControlChars(bv)) {
          showError(form, 'branch', t('err_chars'));
          ok = false;
        } else if (bv.length > 200) {
          showError(form, 'branch', t('err_branch_max'));
          ok = false;
        }
      }
    }

    var reason = form.querySelector('[data-wd-rule="reason"]');
    if (reason) {
      var rv = reason.value || '';
      if (!rv.trim()) {
        showError(form, 'reason', t('err_reason'));
        ok = false;
      } else if (hasIllegalControlChars(rv)) {
        showError(form, 'reason', t('err_chars'));
        ok = false;
      } else if (rv.length > 5000) {
        showError(form, 'reason', t('err_reason_max'));
        ok = false;
      }
    }

    var terms = form.querySelector('[data-wd-rule="terms"]');
    if (terms && !terms.checked) {
      showError(form, 'terms', t('err_terms'));
      ok = false;
    }

    if (!ok) {
      focusFirstInvalid(form);
    }

    return ok;
  }

  /**
   * POST the contact form via fetch so we can tie button state to the network lifecycle
   * (native form submit has no completion callback). Re-enables the button only when the
   * request finishes without navigating away or replacing the document.
   */
  function submitCancellationFormViaFetch(form, submitBtn) {
    var action = typeof form.action === 'string' && form.action ? form.action : window.location.href;
    var body = new URLSearchParams(new FormData(form));
    var shouldReenable = true;

    fetch(action, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      redirect: 'follow',
      headers: {
        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
      },
    })
      .then(function (response) {
        var finalUrl = response.url || '';
        if (response.redirected && finalUrl) {
          shouldReenable = false;
          window.location.assign(finalUrl);
          return null;
        }
        return response.text().then(function (html) {
          var cur = window.location.href.replace(/#.*$/, '');
          var fin = finalUrl.replace(/#.*$/, '');
          if (fin && fin !== cur) {
            shouldReenable = false;
            window.location.assign(finalUrl);
            return;
          }
          try {
            document.open('text/html', 'replace');
            document.write(html);
            document.close();
            shouldReenable = false;
          } catch (docErr) {
            console.warn('[WD TCF] Could not render response HTML:', docErr);
          }
        });
      })
      .catch(function (err) {
        console.warn('[WD TCF] Form submit failed:', err);
      })
      .finally(function () {
        if (shouldReenable && submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  }

  function init() {
    document.querySelectorAll('form.wd-transaction-cancellation__form').forEach(function (form) {
      form.setAttribute('novalidate', '');
      wireNameFieldGuards(form);
      form.addEventListener(
        'submit',
        function (e) {
          if (!validate(form)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          e.preventDefault();
          e.stopImmediatePropagation();
          var submitBtn = form.querySelector('[data-wd-tcf-submit]');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-busy', 'true');
          }
          submitCancellationFormViaFetch(form, submitBtn);
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
